export default __webpack_public_path__ + "static/media/640_dummy2016-tennisclub01-de.9ab9222f.png";